// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".p-itemlist-filter--contact-lens[data-v-6f271638]{max-width:800px}.condition-header[data-v-6f271638]{font-weight:700;padding:10px 0;text-align:center;width:100%}.primary[data-v-6f271638]{background-color:#ff6c5b;color:#fff}.apply-button[data-v-6f271638]{border:0;color:#fff;cursor:pointer;font-weight:700;outline:none;padding:10px 0;width:50%}.clear[data-v-6f271638]{background-color:#bbb}", ""]);
// Exports
module.exports = exports;
